"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.trackEvent = void 0;
var analytics = _interopRequireWildcard(require("@adsk/acs-web-analytics"));
var _issuesBaseProps = require("./issuesBaseProps");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/**
 *
 * it's necessary to sometimes to track events imperatively,
 * outside of the react component context,
 * It's better to call `useAnalytics` when we can though, because then we can later add
 * context conditionally based on a parent component
 */
const trackEvent = event => {
  if (!(0, _issuesBaseProps.areAllIssuesAnalyticsBasePropsReady)()) {
    (0, _issuesBaseProps.enqueueIssuesAnalyticsEvent)(event.name, event.parameters);
    return;
  }
  const baseParams = (0, _issuesBaseProps.getIssuesAnalyticsBaseProps)();
  const allParams = {
    ...baseParams,
    ...event.parameters
  };
  analytics.track(event.name, allParams);
};
exports.trackEvent = trackEvent;
//# sourceMappingURL=trackEvent.js.map